import revive_payload_client_4sVQNw7RlN from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/common/airbaltic-com/investors/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/common/airbaltic-com/investors/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_Jozdw60ZsE from "/builds/common/airbaltic-com/investors/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/builds/common/airbaltic-com/investors/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/builds/common/airbaltic-com/investors/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_KlVwwuJRCL from "/builds/common/airbaltic-com/investors/node_modules/@storyblok/nuxt/dist/runtime/plugin.mjs";
import plugin_eTVJQYlCmx from "/builds/common/airbaltic-com/investors/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/common/airbaltic-com/investors/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import VDompurifyHtml_sAlSVkePvi from "/builds/common/airbaltic-com/investors/plugins/directives/VDompurifyHtml.ts";
import DSGlobals_Qxqz6W0kkO from "/builds/common/airbaltic-com/investors/plugins/directives/DSGlobals.ts";
import sentry_client_shVUlIjFLk from "/builds/common/airbaltic-com/investors/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_Jozdw60ZsE,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_KlVwwuJRCL,
  plugin_eTVJQYlCmx,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  VDompurifyHtml_sAlSVkePvi,
  DSGlobals_Qxqz6W0kkO,
  sentry_client_shVUlIjFLk
]